import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class AlertDialog extends React.Component {
    render() {
        console.log('Alert');
        const { fullScreen, open, title, text } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                className="z_index_dialog_over_dialog "
                onClose={this.props.onCancel}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    <FormattedMessage id={title} />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <FormattedMessage id={text} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onCancel} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.props.onConfirm} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

AlertDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/Alert.js